export default __webpack_public_path__ + "static/media/notice-black.36a9e381.svg";